/**
 * Base domain error class
 * All domain-specific errors should extend this class
 */
export abstract class DomainError extends Error {
  public readonly timestamp: Date;

  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.timestamp = new Date();

    // Maintains proper stack trace for where our error was thrown (Node.js)
    if (
      'captureStackTrace' in Error &&
      typeof (
        Error as unknown as {
          captureStackTrace: (target: object, constructor?: object) => void;
        }
      ).captureStackTrace === 'function'
    ) {
      (
        Error as unknown as {
          captureStackTrace: (target: object, constructor?: object) => void;
        }
      ).captureStackTrace(this, this.constructor);
    }
  }
}
